import { useTranslation } from "react-i18next";

export default function SurveyComplete() {
    const { t } = useTranslation();

    return (
        <div className="flex items-center min-h-100">
            <div className="bg-container p-6 rounded-md w-full mb-8 flex">
                <div className="flex items-center gap-4 mx-auto">
                    <div className="text-center">
                        <h1 className="text-2xl mb-1">{t("surveyResponse.thankYou")}</h1>
                        <h3>{t("surveyResponse.appreciate")}</h3>
                    </div>
                </div>
            </div>
        </div>
    );
}
